/* Related articles above the footer (AJ 2026-10-14). snippets/cq-related-articles.liquid prints an empty slot;
   when it comes within about one screen of the viewport this fetches sections/cq-related-articles.liquid through
   Shopify predictive search and the block's stylesheet, then swaps the slot for the block once both are ready.
   No space is reserved and nothing on screen moves: the slot has no height, the block goes in only while the slot is
   below the visible screen (if the reader is already looking at the footer it waits until they scroll back up), and a
   slot already on screen at load (a short page) is left empty. The article being read is dropped; three are kept.
   Round 4.3 (2026-10-15): a slot with data-compact (product pages) gives the block .cqra--compact and asks each photo
   for the small square's size (sizes), before the block goes in, so no large photo is fetched first. */
(function () {
  var slot = document.querySelector('[data-cq-related]');
  if (!slot || slot.hasAttribute('data-cq-on') || !('IntersectionObserver' in window) || !window.fetch) return;
  slot.setAttribute('data-cq-on', '');

  function css(href) {
    return new Promise(function (done) {
      if (!href || document.querySelector('link[href="' + href + '"]')) return done();
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = l.onerror = done;
      document.head.appendChild(l);
    });
  }

  function trim(u) { return u.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, ''); }

  function load() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var q = slot.getAttribute('data-q');
    var url = q
      ? root + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=article&resources[limit]=6&section_id=cq-related-articles'
      : root + '?section_id=cq-related-articles';
    Promise.all([fetch(url).then(function (r) { return r.ok ? r.text() : ''; }), css(slot.getAttribute('data-css'))])
      .then(function (res) {
        var block = new DOMParser().parseFromString(res[0], 'text/html').querySelector('.cqra');
        var here = trim(location.pathname), kept = 0;
        if (block) block.querySelectorAll('[data-url]').forEach(function (li) {
          if (kept < 3 && trim(li.getAttribute('data-url')) !== here) kept++;
          else li.remove();
        });
        if (!kept) return slot.remove();
        if (slot.hasAttribute('data-compact')) {
          block.classList.add('cqra--compact');
          block.querySelectorAll('.cqra__photo img').forEach(function (img) { img.setAttribute('sizes', '(max-width: 749px) 64px, 80px'); });
        }
        block = document.importNode(block, true);
        var wait = new IntersectionObserver(function (entries) {
          var e = entries[0];
          if (e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.height : window.innerHeight)) return;
          wait.disconnect();
          slot.replaceWith(block);
        });
        wait.observe(slot);
      })
      .catch(function () { slot.remove(); });
  }

  function start() {
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      load();
    }, { rootMargin: '0px 0px 150% 0px' });
    io.observe(slot);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
